import React, { useEffect, useState } from "react";
import AdminLTE, {
  Sidebar,
  Content,
  Row,
  Col,
  Box,
  Button,
  Inputs,
  Label,
} from "adminlte-2-react";
import _ from "lodash";
import controller from "./duck";
import { useSelector, useDispatch } from "react-redux";
import SelectInput from "../utils/SelectInput";
import "react-phone-input-2/lib/style.css";
import TimeInput from "react-time-picker-input";
import { diasOptions } from "../utils/utils";
import moment from "moment";

const { Select2, Date, DateTime, Text } = Inputs;

const estadoOptions = () => [
  { value: "ACTIVO", label: "ACTIVO" },
  { value: "INACTIVO", label: "INACTIVO" },
];
function EditAmbiente({ history, match }) {
  const dispatch = useDispatch();

  const modelEditAmbiente = useSelector((state) => state.updateAmbiente);
  const modelAmbienteById = useSelector((state) => state.ambienteById);

  const [id, setId] = useState(match.params.id);
  const [nombre, setNombre] = useState(null);
  const [estado, setEstado] = useState("ACTIVO");
  const [localId, setLocalId] = useState(null);
  const [maxPersonas, setMaxPersonas] = useState(10);
  const [diasSeleccionados, setDiasSeleccionados] = useState({
    1: true,
    2: true,
    3: true,
    4: true,
    5: true,
    6: true,
    7: true,
  });

  useEffect(() => {
    const data = modelEditAmbiente?.data?.data;
    const error = modelEditAmbiente?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controller.duckUpdateAmbiente.actions.clear());
    }
    if (data) {
      history.push(`/ambientes/${localId}`);
      dispatch(controller.duckUpdateAmbiente.actions.clear());
    }
  }, [modelEditAmbiente]);

  useEffect(() => {
    const data = modelAmbienteById?.data?.data;
    const error = modelAmbienteById?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controller.duckAmbienteById.actions.clear());
    }
    if (data && data.data) {
      setNombre(data.data.nombre);
      setEstado(data.data.estado);
      setLocalId(data.data.localId);
      setMaxPersonas(data.data.maxPersonas);
      const diasSemana = {
        1: data.data.diasSemana[0],
        2: data.data.diasSemana[1],
        3: data.data.diasSemana[2],
        4: data.data.diasSemana[3],
        5: data.data.diasSemana[4],
        6: data.data.diasSemana[5],
        7: data.data.diasSemana[6],
      };
      setDiasSeleccionados(diasSemana);

      dispatch(controller.duckAmbienteById.actions.clear());
    }
  }, [modelAmbienteById]);

  useEffect(() => {
    dispatch(controller.getAmbienteByIdThunk(match.params.id));
  }, []);

  function submit() {
    const diasArray = Object.values(diasSeleccionados);
    if (!nombre || !estado || !maxPersonas || diasArray.length === 0) {
      alert("Por favor complete todos los campos");
      return;
    }

    if (!localId) {
      alert("No se ha podido obtener el ID del local");
      return;
    }

    let data = {
      _id: id,
      nombre,
      estado,
      maxPersonas,
      diasSemana: diasArray,
      localId,
    };

    dispatch(controller.updateAmbienteThunk(data));
  }

  function handleDias(dia, value) {
    let newDias = {
      1: diasSeleccionados[1],
      2: diasSeleccionados[2],
      3: diasSeleccionados[3],
      4: diasSeleccionados[4],
      5: diasSeleccionados[5],
      6: diasSeleccionados[6],
      7: diasSeleccionados[7],
    };
    newDias[dia] = value;
    setDiasSeleccionados(newDias);
  }

  return (
    <Content
      title="Editar ambiente"
      browserTitle="Editar ambiente"
      show={false}
    >
      <Row>
        <Col md="4" mdOffset="4">
          <Box
            title="Editar ambiente"
            footer={
              <>
                <Button text="Cancelar" onClick={() => history.goBack()} />

                <Button
                  type="primary"
                  text="Guardar"
                  pullRight={true}
                  disabled={
                    modelEditAmbiente.loading || modelAmbienteById.loading
                  }
                  onClick={() => submit()}
                />
              </>
            }
          >
            <SelectInput
              value={estado}
              setValue={setEstado}
              label="Estado"
              options={estadoOptions()}
            />
            <Text
              labelPosition="above"
              size="sm"
              label="Nombre"
              value={nombre}
              onChange={(evt) => setNombre(evt.target.value)}
            />
            <Text
              labelPosition="above"
              size="sm"
              inputType="number"
              label="Maximo de personas"
              value={maxPersonas}
              onChange={(evt) => setMaxPersonas(evt.target.value)}
            />

            <Col md="12">
              <text>
                <strong>Dias</strong>
              </text>
            </Col>

            <Col md="4">
              <div style={{ marginTop: 10 }} />
              <Button
                type={diasSeleccionados[1] === true ? "success" : "default"}
                text="Lunes"
                onClick={() =>
                  handleDias(1, diasSeleccionados[1] === true ? false : true)
                }
              />
            </Col>
            <Col md="4">
              <div style={{ marginTop: 10 }} />
              <Button
                type={diasSeleccionados[2] === true ? "success" : "default"}
                text="Martes"
                onClick={() =>
                  handleDias(2, diasSeleccionados[2] === true ? false : true)
                }
              />
            </Col>
            <Col md="4">
              <div style={{ marginTop: 10 }} />
              <Button
                type={diasSeleccionados[3] === true ? "success" : "default"}
                text="Miercoles"
                onClick={() =>
                  handleDias(3, diasSeleccionados[3] === true ? false : true)
                }
              />
            </Col>

            <Col md="4">
              <div style={{ marginTop: 10 }} />
              <Button
                type={diasSeleccionados[4] === true ? "success" : "default"}
                text="Jueves"
                onClick={() =>
                  handleDias(4, diasSeleccionados[4] === true ? false : true)
                }
              />
            </Col>

            <Col md="4">
              <div style={{ marginTop: 10 }} />
              <Button
                type={diasSeleccionados[5] === true ? "success" : "default"}
                text="Viernes"
                onClick={() =>
                  handleDias(5, diasSeleccionados[5] === true ? false : true)
                }
              />
            </Col>
            <Col md="4">
              <div style={{ marginTop: 10 }} />
              <Button
                type={diasSeleccionados[6] === true ? "success" : "default"}
                text="Sabado"
                onClick={() =>
                  handleDias(6, diasSeleccionados[6] === true ? false : true)
                }
              />
            </Col>

            <Col md="4">
              <div style={{ marginTop: 10 }} />
              <Button
                type={diasSeleccionados[7] === true ? "success" : "default"}
                text="Domingo"
                onClick={() =>
                  handleDias(7, diasSeleccionados[7] === true ? false : true)
                }
              />
            </Col>
          </Box>
        </Col>
      </Row>
    </Content>
  );
}

export default EditAmbiente;
